/**
 * @meframe/core-next - Next generation media processing framework
 * Based on WebCodecs API for high-performance video/audio processing
 */

// Core exports
export { Meframe } from './Meframe';
export type { MeframeConfig, MeframeState } from './types';
export { MeframeEvent } from './event/events';

// Model exports
export { CompositionModel } from './model/CompositionModel';
export type {
  CompositionModelData,
  CompositionPatch,
  DirtyRange,
  TimeUs,
  Track,
  Clip,
  Resource,
  Effect,
  Transition,
  Attachment,
  AnimationEffect,
  AnimationKeyframe,
  Transform2D,
} from './model/types';

// Cache exports
export type { CacheConfig, CacheStats } from './cache/types';

// Plugin exports
export type { Plugin, PluginHook } from './plugins/types';

// Utility exports
export { setupCanvasDPI, createHiDPICanvas, checkCanvasDPI } from './utils/canvas-utils';

// Re-export version
export const VERSION = '0.0.1';
